<template>
  <div>
    <el-button size="large" type="text" @click="backHome">返回首页</el-button>
    <!--
    <el-button size="large" type="text" @click="backPrev">返回上一页({{ second }}s)</el-button>
    -->
    <el-button size="large" type="text" @click="backPrev">返回上一页</el-button>
  </div>
</template>

<script>
export default {
  name: 'backBtnGroup',
  data () {
    return {
      second: 5,
      timer: null
    }
  },
  methods: {
    backHome () {
      this.$router.push("/")
    },
    backPrev () {
      this.$router.go(-1)
    }
  },
  mounted () {
    /*
    this.timer = setInterval(() => {
      if (this.second === 0) this.backPrev()
      else this.second--
    }, 1000)
    */
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>

<style>
.error-page{
    width: 100%;
    height: 100%;
    position: relative;
    background: #fff;
}
.content-con{
    width: 700px;
    height: 600px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -60%);
}
.content-con img{
    display: block;
    width: 100%;
    height: 100%;
}
.text-con{
    position: absolute;
    left: 0px;
    top: 0px;
}
.content-con h4{
    position: absolute;
    left: 0px;
    top: 0px;
    font-size: 80px;
    font-weight: 700;
    color: #348EED;
}
.content-con h5{
    position: absolute;
    width: 700px;
    left: 0px;
    top: 100px;
    font-size: 20px;
    font-weight: 700;
    color: #67647D;
}
.back-btn-group{
    position: absolute;
    right: 0px;
    bottom: 20px;
}
</style>
